import { useContext } from 'react';
import CardTwo from '../Cards/CardTwo/CardTwo';
import './Buy.scss';
import { CurrentLangContext, LangContext } from '../../contexts/contexts';

function Buy() {
  const langs = useContext(LangContext);
  const buyLangs = langs.buy;

  const CurrentLangC = useContext(CurrentLangContext);
  const currentLang = CurrentLangC[0];

  return (
    <section id="buy" className="Buy">
      <h1 className="Buy_title">{buyLangs.title[currentLang]}</h1>
      <div className="Buy_container">
        <div className="buy_content">
          <div className="buy_immo">
            <CardTwo />
            <CardTwo />
            <CardTwo />
            <CardTwo />
            <CardTwo />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Buy;